import * as angular from "angular";

RLSortColumn.$inject = ["$compile"];
export function RLSortColumn($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            sortField: "=",
            sortDir: "=",
            colSortField: "@rlSortColumn",
            sortClick: "&",
            readOnly: "@?",
            onSortChanged: '&?'
        },
        link: (scope: IRLSortColumnScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            var template = "<i ng-show='colSortField==sortField' class='fa' ng-class='{\"fa-sort-up\":sortDir==0,\"fa-sort-down\":sortDir==1}'></i>";
            var el = angular.element(template);
            var compiled = $compile(el);

            element.bind("click", () => {
                if (!scope.readOnly) {
                    if (scope.sortField == scope.colSortField) {
                        scope.sortDir = scope.sortDir == 1 ? 0 : 1;
                    } else {
                        scope.sortField = scope.colSortField;
                    }
                    scope.$apply();
                    scope.sortClick();
                    scope.$apply();
                    if (scope.onSortChanged != null) {
                        scope.$apply(() => {
                            scope.onSortChanged({ sortField: scope.sortField, sortDir: scope.sortDir });
                        });
                    }
                }
            });

            element.append(el);

            compiled(scope);
        }
    };
    return directive;
}

interface IRLSortColumnScope extends ng.IScope {
    sortField: string;
    sortDir: number;
    colSortField: string;
    sortClick(): void;
    readOnly: boolean;
    onSortChanged(event: { sortField: string, sortDir: number }): any;
}
